export default __webpack_public_path__ + "static/shrink-piercing_1_1-3722bd91e36b639254d0f4d894259fb6.mp4";